"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.05;
  return <section ref={ref} className="relative w-full h-screen overflow-hidden !shadow-[0px_2px_4px_rgba(20,21,31,0.15),_0px_1px_2px_rgba(20,21,31,0.10)] !text-[hsl(48,96%,89%)] !border-[hsl(48,100%,96%)] !border-1 border-solid !bg-transparent !bg-[url(https://rational-stag.10web.cloud/wp-content/uploads/2026/01/gold_pattern_texture.webp)]">
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-slow ease-smooth" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/professional_office_skyline_view.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} />

      <div className="relative z-10 flex h-full items-center justify-center px-4 !text-[hsl(48,100%,96%)] sm:px-6 md:px-8 lg:px-12">
        <div className={`max-w-5xl w-full text-center transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <h1 className="font-display font-bold leading-tight !text-[hsl(22,78%,26%)] !text-4xl md:!text-5xl lg:!text-6xl xl:!text-7xl">
            Salem Ballama Auditing
          </h1>
          <p className="mt-4 leading-relaxed !font-bold !font-serif !text-[hsl(0,0%,100%)] !text-base md:!text-lg lg:!text-xl sm:mt-6">
            Dubai-based professional firm Empowering UAE enterprises through financial clarity and regulatory excellence.
          </p>
          <p className="mt-3 leading-relaxed !font-serif !font-semibold !text-[hsl(0,0%,100%)] !text-sm md:!text-base lg:!text-lg sm:mt-4">&nbsp;we combine decades of local expertise with a global perspective to deliver high-impact Audit, Corporate Tax, and Management Advisory services. From Dubai to the wider GCC, we are the trusted architects of your financial compliance</p>
        </div>
      </div>
    </section>;
}